import { MeanOfPrevention } from '../../domain/mean-of-prevention';
import { mapper } from '../../tools/mapping/mapper';
import { MeanOfPreventionEntity } from '../entity';
import type { AppDB } from '../db';

export class MeanOfPreventionRepository {
    constructor(private readonly database: AppDB) {}


    async clearMeanOfPreventById(ids: number[]) {
        await this.database.meanOfPreventions.where('Id').anyOf(ids).toArray(async phe => {
            for (let i = 0; i < phe.length; i++) {
                if (phe && phe[i].Id !== undefined) {
                    await this.database.meanOfPreventions.where('Id').equals(phe[i].Id!).delete();
                }
            }
        })
    }

    async getMeanOfPreventionById(id: number) {
        return await this.database.meanOfPreventions.where('Id').equals(id).first(async mope => {
            const mop = mapper.map(mope, MeanOfPreventionEntity, MeanOfPrevention);
            return mop;
        });
    }

    async attachMeanOfPrevention(processTechnique: MeanOfPrevention, processId: number) {
        let mopId: number;
        const mope = mapper.map(processTechnique, MeanOfPrevention, MeanOfPreventionEntity);

        const pe = await this.database.getProcessEntityById(processId);
        mopId = await this.database.meanOfPreventions.add(mope);
        await this.database.process.update(processId, {
            MeanOfPreventionIds: pe?.MeanOfPreventionIds ? [...pe.MeanOfPreventionIds, mopId] : [mopId]
        });

        return mopId;
    }
}
